import { createAction } from '@reduxjs/toolkit';

export const clearTermsAndConditions = createAction('termsAndConditions/CLEAR_TERMS_AND_CONDITIONS');
export const fetchTermsAndConditions = createAction('termsAndConditions/FETCH_TERMS_AND_CONDITIONS');
export const setTermsAndConditions = createAction('termsAndConditions/SET_TERMS_AND_CONDITIONS');
